import { render } from "./SelectionPreview.vue?vue&type=template&id=773a6d86&scoped=true&ts=true"
import script from "./SelectionPreview.vue?vue&type=script&lang=ts"
export * from "./SelectionPreview.vue?vue&type=script&lang=ts"

import "./SelectionPreview.vue?vue&type=style&index=0&id=773a6d86&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-773a6d86"]])

export default __exports__